import React from "react";
import { Col, Row } from "antd";
import Footerlogo from "../../images/insta.png";
import Footerlogo1 from "../../images/linkd.png";
import Footerlogo2 from "../../images/bask.png";
import Footerlogo3 from "../../images/be.png";
import Add from "../../images/add.png";
import "./style.css";
function Footer2() {
  return (
    <div className=" mainfooter">
      <Row justify="space-between">
        <Col lg={10} md={10} xs={24}>
          <div className="   d-flex justify-content-center align-items-center mt-4">
            <div>
              <img className="addlogo" src={Add} alt="" />
            </div>
            <div>
              <p className="footertext">
                2022 Connectyfy. All Rights Reserved.
              </p>
            </div>
          </div>
        </Col>
        <Col lg={10} md={10} xs={24}>
          <div className="   d-flex justify-content-center align-items-center">
            <div className="border shadow p-1 m-1  bg-body rounded">
              <img src={Footerlogo} alt="" />
            </div>
            <div className="border shadow p-1 m-1  bg-body rounded">
              <img src={Footerlogo1} alt="" />
            </div>
            <div className="border shadow p-1 m-1  bg-body rounded">
              <img src={Footerlogo2} alt="" />
            </div>
            <div className="border shadow p-1 m-1  bg-body rounded">
              <img src={Footerlogo3} alt="" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Footer2;
